import { useSyncExternalStore } from 'react';
import { LLStore } from '../store';

export function useStore<Store extends LLStore<unknown>>(
  store: Store
): Store['value'] {
  return useSyncExternalStore(store.subscribe, store.get);
}
